import type React from "react";
import { Modal } from "../../core/basic/Modal";
import InsightDetails, { type InsightData } from "./InsightDetails";
import { css } from "../../../../styled-system/css";
import { Box, HStack, VStack } from "../../../../styled-system/jsx";
import Pill from "../Pill";
import { FaClock } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useDateFormatter } from "../../../i18n/useDateFormatter";

interface InsightDetailsModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  insight: InsightData;
  onActionClick?: (action: unknown) => void;
}

const InsightDetailsModal: React.FC<InsightDetailsModalProps> = ({ isOpen, onOpenChange, insight, onActionClick }) => {
  const { t } = useTranslation(["chat"]);
  const fmt = useDateFormatter("shortDateTime");
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={
        <VStack gap="small" width="100%">
          <span>{insight.title}</span>
          <HStack justifyContent={"space-between"} alignItems="center" width="100%">
            <Pill variant={insight.metadata?.result?.status as "info" | "success" | "warning" | "error"}>
              {insight.metadata?.result?.status || "info"}
            </Pill>
            <HStack gap="xsmall" alignItems="center" color="#6B7280">
              <FaClock className={css({ fontSize: "12px" })} />
              <span className={css({ fontSize: "12px" })}>
                {t(($) => $.chat["Created {date}"], {
                  date: fmt.format(new Date(insight.created_on)),
                })}
              </span>
            </HStack>
          </HStack>
        </VStack>
      }
      css={{
        width: { base: "95%", lg: "80%" },
        maxWidth: "1200px",
      }}
    >
      <Box
        className={css({
          maxHeight: "calc(85vh - 100px)",
          paddingX: "xlarge",
          paddingBottom: "large",
          overflowY: "auto",
        })}
      >
        <InsightDetails insight={insight} onActionClick={onActionClick} hideTitle />
      </Box>
    </Modal>
  );
};

export default InsightDetailsModal;
